import { useEffect } from 'react';
import { useAuth } from '../../auth/AuthProvider.js';
import { otaEarlyAccessOf, setOtaEarlyAccess } from './ota.js';

/**
 * OTA early access (lib/native/ota.ts, header 3e): the signed-in session's own
 * `otaEarlyAccess` (`/api/auth/me`) becomes the `ota-early` part of the updater's
 * `custom_id`; signed out, another account or the flag turned false → dropped.
 * Mounted once INSIDE `<AuthProvider>` (it reads `useAuth`). Renders nothing; a
 * no-op for the plugin on the web.
 */
export function OtaBridge(): null {
  const { user, loading } = useAuth();
  const early = otaEarlyAccessOf({ loading, user });
  useEffect(() => {
    setOtaEarlyAccess(early);
  }, [early]);
  return null;
}
